export const nipponRatingLegendItems = [
  { score: '1', label: 'Poor', description: 'Missing, vague, weak, or not credible' },
  { score: '2', label: 'Limited', description: 'Limited evidence or plan, but still weak' },
  { score: '3', label: 'Moderate', description: 'Partially clear or partially actionable' },
  { score: '4', label: 'Strong', description: 'Strong and convincing, but not fully detailed or measurable' },
  { score: '5', label: 'Excellent', description: 'Specific, credible, measurable, and complete' }
];

export const nipponRatingNaItem = {
  score: 'N/A',
  label: 'Not Applicable',
  description: 'Not asked or not answered; excluded from scoring.'
};

export const nipponPhaseNotes = {
  CompetencyAssessment: 'Competency Assessment: score reflects strength of past examples and results.',
  M0ReadinessAssessment: 'M0 Readiness Assessment: score reflects strength of future joining and launch planning.',
  ResumeProfileVerification: 'Resume Profile Verification: compares spoken interview facts with the saved candidate profile and extracted resume.'
};

export const getNipponRatingLabel = (value) => {
  const text = String(value ?? '').trim();
  const item = nipponRatingLegendItems.find((entry) => entry.score === text);
  if (item) return `${item.score} - ${item.label}`;
  if (text.toUpperCase() === 'N/A' || text.toLowerCase() === 'not applicable') return 'N/A';
  return text || 'N/A';
};

// Maps a rating value to a semantic tier + dot count for compact visual rendering
// (e.g. a filled-dot bar next to the text label). Only exact legend scores ('1'-'5')
// produce a tier other than 'na', so it stays in sync with nipponRatingLegendItems.
export const getNipponRatingTone = (value) => {
  const text = String(value ?? '').trim();
  const item = nipponRatingLegendItems.find((entry) => entry.score === text);
  if (!item) return { tier: 'na', dotCount: 0 };
  const score = Number(item.score);
  if (score <= 2) return { tier: 'negative', dotCount: score };
  if (score === 3) return { tier: 'neutral', dotCount: score };
  return { tier: 'positive', dotCount: score };
};

export const nipponCompactLegendText = `${nipponRatingLegendItems
  .map((item) => `${item.score} ${item.label}`)
  .join(' | ')} | ${nipponRatingNaItem.score} ${nipponRatingNaItem.label}`;

export const nipponPhaseInterpretationText = [
  nipponPhaseNotes.CompetencyAssessment,
  nipponPhaseNotes.M0ReadinessAssessment,
  nipponPhaseNotes.ResumeProfileVerification
].join(' ');
